import React, { useState } from "react";
import { api, API, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, label = "Photo" }) {
  const [loading, setLoading] = useState(false);
  const src = value ? (value.startsWith("http") || value.startsWith("data:") ? value : `${API}/files/${value}`) : null;

  async function handle(e) {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(`${API}/files/${data.path}`);
      toast.success("Image uploaded");
    } catch (err) { toast.error(apiError(err)); } finally { setLoading(false); }
  }

  return (
    <div className="flex items-center gap-3">
      <div className="h-16 w-16 rounded-lg border-2 border-dashed border-slate-200 flex items-center justify-center overflow-hidden bg-slate-50">
        {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : <Upload className="h-5 w-5 text-slate-300" />}
      </div>
      <div className="flex gap-2">
        <label className="cursor-pointer inline-flex items-center gap-2 text-sm px-3 py-2 rounded-lg border border-slate-200 hover:bg-slate-50">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />} {label}
          <input type="file" accept="image/*" className="hidden" onChange={handle} data-testid="image-upload-input" />
        </label>
        {value && <Button type="button" variant="ghost" size="sm" className="text-red-500" onClick={() => onChange(null)}><X className="h-4 w-4" /></Button>}
      </div>
    </div>
  );
}
